import { render } from "./TelegramSendDialog.vue?vue&type=template&id=3d09766e&scoped=true"
import script from "./TelegramSendDialog.vue?vue&type=script&lang=js"
export * from "./TelegramSendDialog.vue?vue&type=script&lang=js"

import "./TelegramSendDialog.vue?vue&type=style&index=0&id=3d09766e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d09766e"]])

export default __exports__